import { render, staticRenderFns } from "./GeneratedForms.vue?vue&type=template&id=63b2ec04&"
import script from "./GeneratedForms.vue?vue&type=script&lang=js&"
export * from "./GeneratedForms.vue?vue&type=script&lang=js&"
import style0 from "./GeneratedForms.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports